// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"9ec647cf","787":"0bcb38d6","850":"a9edf5b1"}[chunkId] + ".chunk.js";
};